export const buildPlayMoveKey = (
  roomId: string,
  address: string,
  chainId: number | string,
  round: number,
) => `${roomId}${address}${chainId}${round}`;
